import SearchIcon from "@/assets/images/icons/search.svg?inline";
import AvatarIcon from "@/assets/images/icons/chat_avatar.svg?inline";
import LogoIcon from "@/assets/images/black-logo.png";
import LogoWhite from "@/assets/images/white-logo.png";
import PhoneIcon from "@/assets/images/icons/phone.svg?inline";
import EmailIcon from "@/assets/images/icons/email.svg?inline";
import MarkerIcon from "@/assets/images/icons/report_place.svg?inline";

import MesssagesCounter from "../MessagesCounter";

import {VueAutosuggest} from "vue-autosuggest";
import debounce from "lodash/debounce";

import {mapGetters, mapState} from "vuex";

import {PLACES_SUGGESTIONS, SIGN_OUT} from "./gql/HeaderQueries";

export default {
  name: "appHeader",

  data() {
    return {
      // placesQuery: "",
      placesRequestQuery: "",
      selected: "",
      places: [],
      skipQuery: true,
      skipPlacesQuery: true,

      skipPropertiesQuery: true,
      searchParams: {
        address: {
          placeId: ""
        },
        page: 1,
        sort: "score",
        filters: []
      },

      limitPosition: 60,
      scrolled: false,
      isShowMenu: false,
      isMainPage: false,
      isStartQuiz: false,
      isOpenSearchForm: false
    };
  },

  apollo: {
    places: {
      query: PLACES_SUGGESTIONS,
      variables() {
        return {
          address: this.placesRequestQuery
        };
      },

      skip() {
        return this.skipPlacesQuery;
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    ...mapState(["twilioMessagesCounter", "user"]),

    isMessagesAvaliable() {
      return this.twilioMessagesCounter != null;
    },

    date() {
      return this.$moment().format("MMM D, YYYY");
    },

    userAvatar() {
      return this.currentUser.avatar;
    },

    cacheFilters() {
      if (this.$store.state.filters.address) {
        return JSON.parse(JSON.stringify(this.$store.getters.getFilters));
      } else {
        let searchParams = JSON.parse(localStorage.getItem("searchParams"));
        if (searchParams) {
          this.$store.commit("setFilters", searchParams);
          return searchParams;
        } else {
          this.searchParams.address.placeId = this.selected.item.placeId;

          this.$store.commit("setFilters", this.searchParams);
          return this.searchParams;
        }
      }
    },

    LogoIcon() {
      return LogoIcon;
    },

    LogoWhite() {
      return LogoWhite;
    },

    filteredOptions() {
      const filtered = [];

      this.skipPlacesQuery = true;

      if (!this.places) {
        return [];
      }

      this.places.forEach(r => {
        filtered.push({
          label: r.type,
          data: r.places,
          limit: 5,
          onSelected: selected => {
            this.selected = selected.item;
          }
        });
      });

      return Object.freeze(filtered);
    },

    placesQuery: {
      get: function () {
        if (
          this.$store.getters.doneProperties &&
          this.$store.getters.doneProperties.address
        ) {
          return this.$store.getters.doneProperties.address.description;
        }
      },
      set: debounce(function (newValue) {
        if (newValue.length > 2) {
          this.placesRequestQuery = newValue;
          this.skipPlacesQuery = false;
        }
      }, 300)
    },

    isMobile() {
      return this.$mq === "md" || this.$mq === "sm" || this.$mq === "xs";
    },

    isShowSearchForm() {
      if (this.isMobile) {
        return this.isOpenSearchForm;
      } else {
        return true;
      }
    },

    profileTitle() {
      if (this.currentUser.firstName || this.currentUser.lastName) {
        let firstName = this.currentUser.firstName
          ? this.currentUser.firstName
          : "";
        let lastName = this.currentUser.lastName
          ? this.currentUser.lastName
          : "";

        return firstName + " " + lastName;
      } else if (this.currentUser.email) {
        return this.currentUser.email;
      } else {
        return this.currentUser.phone;
      }
    },

    isHeaderTransparent() {
      return (
        (this.$route.name == "home" ||
          this.$route.name == "homeowners" ||
          this.$route.name == "agents") &&
        !this.isStartQuiz &&
        !this.scrolled
      );
    }
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted: function () {
    let self = this;
    this.$root.$on("setStartQuiz", function (e) {
      self.isStartQuiz = e;
    });

    if (!this.isMobile) {
      this.isOpenSearchForm = false;
    }
  },

  beforeDestroy() {
    this.isShowMenu = false;
  },

  methods: {
    handleScroll() {
      if (!this.isMobile && !this.$route.name == "home") {
        return false;
      }

      if (this.limitPosition < window.scrollY) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
      this.lastPosition = window.scrollY;
    },

    selectHandler(item) {
      if (item == null) {
        this.initSearchByButton();
      } else {
        this.selected = item;
        this.places = [];

        if (this.isMobile) {
          this.isOpenSearchForm = false;
        }

        this.sendRequest(this.selected.item.placeId);
      }
    },

    getSuggestionValue(suggestion) {
      return suggestion.item.description;
    },

    userLoggedIn() {
      this.$forceUpdate();
    },

    sendRequest(placeId) {
      this.$set(this.cacheFilters.address, "placeId", placeId);

      this.$store.commit("setFilters", this.cacheFilters);

      this.$nextTick(() => {
        if (this.$route.name != "properties") {
          this.$router.push({name: "properties"});
        }
      });
    },

    initSearchByButton() {
      if (this.places["0"]) {
        if (this.isMobile) {
          this.isOpenSearchForm = false;
        }

        this.sendRequest(this.places["0"].places["0"].placeId);
      }
    },

    toggleMenu() {
      this.isShowMenu = !this.isShowMenu;
    },

    reloadPage() {
      this.$root.$emit("reloadMainPage");
    },

    showSearchForm() {
      this.isOpenSearchForm = !this.isOpenSearchForm;
    },

    hideSearchForm() {
      if (this.isMobile && this.filteredOptions.length == 0) {
        this.isOpenSearchForm = false;
      }
    },

    signOut() {
      if (this.isMobile) {
        this.signOutRequest();
      } else {
        if (confirm("Do you really want to sign out?")) {
          this.signOutRequest();
        }
      }
    },

    signOutRequest() {
      this.$apollo
        .mutate({
          mutation: SIGN_OUT
        })
        .then(() => {
          this.$store.dispatch("destroyUser");

          // location.reload(true);
          this.$router.push({
            name: "blog"
          });
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        });
    }
  },

  components: {
    SearchIcon,
    VueAutosuggest,
    AvatarIcon,
    PhoneIcon,
    EmailIcon,
    MarkerIcon,
    MesssagesCounter
  }
};
